import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code-medium, syntax, brackets, dev"} maskId="square-outlined-radius-0-stroke-1-IconCodeMedium"><path d="M17 7.5L21.5 12L17 16.5" stroke="currentColor" strokeLinecap="square"/><path d="M7 16.5L2.5 12L7 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
}));

export default IconCodeMedium;
